/* eslint-disable no-restricted-globals */
/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { makeApi, URLS } from "Utils/apiURL";

const PipedriveOAuth = () => {
  const [isConnected, setConnected] = useState(false);

  const getPipedriveAuthAccountsInfo = () => {
    try {
      const url = new URL(window.location.href);
      const code = url?.searchParams.get("code");
      !code
        ? url?.href?.indexOf("access_denied") !== -1
          ? closeWindow()
          : ""
        : "";
      return { code };
    } catch (e) {
      closeWindow();
      return null;
    }
  };

  const connectPipedriveApp = async () => {
    const { code = "" } = getPipedriveAuthAccountsInfo();
    try {
      if (code) {
        const config = {
          url: `${URLS.connectOrDisconnectPipedrive}?code=${code}`,
          method: "POST"
        };
        const res = await makeApi(config);
        const { pipedriveConnected = false, responseCode = "" } =
          res?.data || {};
        const resCode = responseCode?.toString() || "500";
        opener?.postMessage({ code: resCode, type: "PIPEDRIVE_CONNECT_OAUTH" });
        if (pipedriveConnected === "200") {
          setConnected(true);
          setTimeout(() => {
            closeWindow();
          }, 1000);
        } else {
          closeWindow();
        }
      } else {
        closeWindow();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const closeWindow = () => {
    window?.close();
  };

  useEffect(() => {
    connectPipedriveApp();
  }, []);

  return (
    <div className="pageClass">
      <div className="pageCont">
        <div className="connectAppSection">
          {isConnected ? (
            <div>Successfully Connected</div>
          ) : (
            <div>
              <div>Please wait while we connect your Pipedrive account</div>
              <div style={{ marginTop: "10px" }}> Connecting... </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PipedriveOAuth;
export { PipedriveOAuth };
